export default "__VITE_ASSET__Czv7CoDR__"